import React, { useEffect, useState } from 'react';
import { Box, Button, Link } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import Plugin, { PluginProps } from '../Plugin';

const EditorBlock = (props: PluginProps) => {
  const { content, changeHighlightSectionType } = props;
  const { t } = useTranslation();
  const [showEmbedEdtitor, setShowEmbedEdtitor] = useState(false);
  const contentData = content.data;
  const contentHeight = contentData.height || 500;

  useEffect(() => {
    window.onmessage = (e) => {
      if (e && e.data && e.data.event === 'editor_run_tests') {
        const { passing } = e.data;
        if (passing) {
          changeHighlightSectionType('todo');
        } else {
          changeHighlightSectionType('danger');
        }
      }
    };
  }, []);

  if (!contentData.show_editor) {
    return (
      <div style={{ width: '100%', textAlign: 'center' }}>
        <Link href={contentData.href} target="_blank">
          <Button size="lg" colorScheme="blue">
            {contentData.label}
          </Button>
        </Link>
      </div>
    );
  }
  return (
    <>
      <div className="editor-block-nav"></div>
      <div className="editor-block-embed" style={{ textAlign: 'center', overflow: 'visible', maxHeight: 'none !important' }}>
        <div className="editor-container">
          <div
            style={{
              display: showEmbedEdtitor ? 'block' : 'none',
              flex: showEmbedEdtitor ? 1 : 0,
            }}
          >
            <iframe
              style={{
                width: '100%',
                height: contentData.height,
              }}
              src={contentData.href + '?is_small=true'}
              scrolling="auto"
              frameBorder={0}
              marginHeight={0}
              marginWidth={0}
              height={contentData.height}
            />
          </div>
          {!showEmbedEdtitor && (
            <Button
              colorScheme="blue"
              variant="outline"
              background="white"
              onClick={() => {
                setShowEmbedEdtitor(true);
              }}
              size="lg"
            >
              {t('plugin.editor.startCoding')}
            </Button>
          )}
        </div>
        <Link href={contentData.href} target="_blank" rel="noreferrer">
          <Button colorScheme="blue" variant="outline" size="lg" mt="4">
            {t('plugin.editor.openInEditor')}
          </Button>
        </Link>
      </div>
    </>
  );
};

export default EditorBlock;
